import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Register } from '../../_models/register';
import { Notification } from '../../notification';
import { Caller } from '../../_models/caller';
import { ApiIntegration } from '../../_services/api.integration';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { User } from '../../_models/user';

@Component({
  selector: 'app-edit-notification',
  templateUrl: './edit-notification.component.html',
  styleUrls: ['./edit-notification.component.css']
})
export class EditNotificationComponent implements OnInit {
  statusText: string = "";
  notificationTypes: any;
  selectDeleteNotify: any;
  notificationForDelete: any;
  notificationId: any;
  id: number;
  status: string;
  notificationToModify: any;
  tabClicked: string = "all";
  typeStatusText: string = "";
  descStatusText: string = "";

  editNotification: Notification = {
    notificationId: 0,
    description: "",
    type: "",
    id: 0,
    status: ""
  }
  constructor(private alertService: AlertService, public user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute, private api: ApiIntegration, public notification: Notification, public register: Register, public caller: Caller, public g: Globals) {
    this.api.getNotificationsById(this.route.snapshot.params['notificationId'], this.user.organizationId).subscribe((data: any) => { this.editNotification = data; }, err => { console.log(err); });
    this.g.page = "Edit Notification";
  }

  ngOnInit() {
  }
  TypeStatusText() {
    this.typeStatusText = "";
    if (this.editNotification.type == '' || this.editNotification.type === null || this.editNotification.type === undefined || this.editNotification.type === 'undefined') {
      this.typeStatusText = 'Please enter Notification Type';
    }
  }
  DescStatusText() {
    this.descStatusText = "";
    if (this.editNotification.description == '' || this.editNotification.description === null || this.editNotification.description === undefined || this.editNotification.description === 'undefined') {
      this.descStatusText = 'Please enter Notification Description';
    }
  }

  submitUpdateNotify() {
    this.g.loaderDisplay = "display";
    this.typeStatusText = "";
    this.descStatusText = "";
    this.statusText = "";

    if (this.editNotification.type == '' || this.editNotification.type === null || this.editNotification.type === undefined || this.editNotification.type === 'undefined') {
      this.typeStatusText = 'Please enter Notification Type';
    }

    if (this.editNotification.description == '' || this.editNotification.description === null || this.editNotification.description === undefined || this.editNotification.description === 'undefined') {
      this.descStatusText = 'Please enter Notification Description';
    }
    if (this.typeStatusText != "" || this.descStatusText != "") {
      this.g.loaderDisplay = "";
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateNotification', {
      "description": this.editNotification.description,
      "notificationId": this.editNotification.id,
      "organizationId": 1,
      "status": this.editNotification.status,
      "type": this.editNotification.type
    },
      {
        headers: header1
      }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == '200') {
          this.alertService.success('Notification', 'edited successfully');

          this.router.navigate(['/admin/notify']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
          this.statusText = "Edit notification Failed, please re-try.";
        }
      )
  }

}
